<template>
  <div class="apply-list">
    <h2 class="apply-list__title">
      {{ title }}
    </h2>
    <div class="apply-list__back">
      <b-button variant="primary" class="btn-icon" @click="handleBack">
        <feather-icon icon="ArrowLeftIcon" />
      </b-button>
    </div>

    <gtable-crud
      ref="gtable-crud"
      :data="formatData"
      :option="option"
      :page="page"
      :loading="loading"
      :permission="permissionList"
      :before-open="beforeOpen"
      @searchChange="searchChange"
      @searchReset="searchReset"
      @pageChange="pageChange"
      @pageSizeChange="pageSizeChange"
      @rowDel="rowDel"
      @refresh-change="refreshChange"
      @submit-add="submitAdd"
      @submit-edit="submitEdit"
    >
      <!-- 自定义列 -->
      <template slot="table-row" slot-scope="{ row, column }">
        <span v-if="column.field == 'form'">
          <template v-for="(item, key) in row.form">
            <p :key="key">
              {{ $t(`_staff.labelEmploymentApplication.${key}`) }}:&nbsp;
              <span class="text-primary">{{ item }}</span>
            </p>
          </template>
        </span>
      </template>
      <template slot="headMenuLeft" slot-scope="{ row }">
        <my-tooltip
          v-if="exportObj.model === 'table'"
          :tooltip="exportObj.title || $t('components.btns.download')"
        >
          <b-button
            variant="warning"
            class="btn ml-0-5 mr-0-5"
            size="sm"
            @click="handleCustomDownload(exportObj)"
          >
            <feather-icon :icon="exportObj.icon || 'DownloadIcon'" size="18" />
          </b-button>
        </my-tooltip>
        <my-tooltip :tooltip="$t('_components.btns.download')">
          <a-button
            type="primary"
            style="border-radius: 8px;width: 50px;height: 32px;"
            size="sm"
            :loading="downloading"
            @click="handleDownload"
          >
            <feather-icon icon="DownloadIcon" size="18" />
          </a-button>
        </my-tooltip>
        <!-- 新增 -->
        <my-tooltip v-if="formId != 105" :tooltip="$t('_components.btns.add')">
          <b-button
            v-if="isWorker"
            variant="primary"
            class="btn ml-0-5 mr-0-5"
            size="sm"
            @click="handleStepChange('add', row)"
          >
            <feather-icon icon="PlusIcon" size="18" />
          </b-button>
        </my-tooltip>
      </template>
      <template slot="menuLeft" slot-scope="{ row }">
        <!-- <my-tooltip :tooltip="$t('_components.btns.view')">
          <feather-icon
            icon="SearchIcon"
            class="text-primary cursor-pointer mr-1"
            size="20"
            @click="handleStepChange('view', row)"
          />
        </my-tooltip> -->
        <my-tooltip
          v-if="row.status !== 1"
          :tooltip="$t('_components.btns.view')"
        >
          <feather-icon
            icon="SearchIcon"
            class="text-warning cursor-pointer ml-1"
            size="20"
            @click="handleStepChange('viewPage', row)"
          />
        </my-tooltip>
        <my-tooltip
          v-if="exportObj.model === 'row' && passQuery(exportObj.query, row)"
          :tooltip="exportObj.title || $t('_components.btns.download')"
        >
          <feather-icon
            :icon="exportObj.icon || 'DownloadIcon'"
            class="text-warning cursor-pointer ml-1"
            size="20"
            @click="handleCustomDownload(exportObj, row)"
          />
        </my-tooltip>

        <my-tooltip
          v-if="formId == 105 && row.status == 9"
          :tooltip="exportObj.title || $t('_components.btns.download')"
        >
          <feather-icon
            :icon="exportObj.icon || 'DownloadIcon'"
            class="text-warning cursor-pointer ml-1"
            size="20"
            @click="downloadPDF(row)"
          />
        </my-tooltip>
        <my-tooltip :tooltip="$t('_components.btns.send')">
          <feather-icon
            v-if="getStatusOption(row.status).send && isWorker"
            icon="SendIcon"
            class="text-success cursor-pointer"
            size="20"
            @click="handleStepChange('send', row)"
          />
        </my-tooltip>
        <my-tooltip :tooltip="$t('_components.btns.cancel')">
          <feather-icon
            v-if="row.status === 5 && viewAll === true"
            icon="XIcon"
            style="margin-left: 5px"
            class="text-danger cursor-pointer"
            size="20"
            @click="cancelProcess(row)"
          />
        </my-tooltip>
        <my-tooltip
          v-if="row.status === 1"
          :tooltip="$t('_components.btns.edit')"
        >
          <feather-icon
            icon="Edit2Icon"
            class="text-warning cursor-pointer ml-1"
            size="20"
            @click="handleStepChange('edit', row)"
          />
        </my-tooltip>
      </template>
    </gtable-crud>

    <c-modal
      :visible="modalShow"
      :title="modalTitle"
      size="lg"
      @close="modalShow = false"
      @modelConfirm="handleModelConfirm"
    >
      <template slot="content">
        <my-form
          v-if="getFormOption(stepMethodKey)"
          ref="overFormRef"
          :data="rowData"
          :loading="modalFormLoading"
          :option="getFormOption(stepMethodKey)"
          :footer-visible="false"
          width="auto"
        />
        <span v-else>
          {{ $t(`_staff.prompt.base.${stepMethodKey}Message`) }}
        </span>
      </template>
    </c-modal>

    <!-- 提交面试结果或者View页面 -->
    <c-drawer v-model="drawerShow" :before-close="handleBeforeClose">
      <component
        :is="stepMethodKey"
        v-if="drawerShow"
        :id="processId"
        :process-id="processId"
        :form-id="formId"
        @close="handleDrawerClose"
      />
    </c-drawer>
  </div>
</template>

<script>
import applyAPI from '@/api/apply/index'
import templateFormAPI from '@/api/templateForm/index'
import CModal from '@/components/crud/modal.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import MyForm from '@/components/myForm/index.vue'
import {
  downLoadAllLeave,
  downLoadLeave,
  downLoadWorkerForm,
  downLoadAllWorkerForm,
  downLoadLeaveJob,
  downLoadAllLeaveJob,
  customDownload,
} from '@/api/worker/process'
import {
  downLoadProcess,
  downLoadAllProcess,
} from '@/api/worker/passportUpdate'
import formAPI from '@/api/base/formCustom'

import { BButton, BFormRadio } from 'bootstrap-vue'
import CDrawer from '@/components/drawer.vue'
import MyTooltip from '@/components/myTooltip.vue'
import { mapGetters } from 'vuex'
import edit from '@/views/apply/components/edit.vue'
// import viewPage from '@/views/apply/components/viewPage.vue';
import viewPage from '@/views/worker/apply/components/view.vue'
import { templateFormat } from '@/util/func'
import add from '@/views/worker/apply/components/add.vue'
import { deepClone } from '@/util/util'

export default {
  components: {
    CModal,
    MyForm,
    BButton,
    add,
    edit,
    viewPage,
    CDrawer,
    MyTooltip,
    BFormRadio,
  },
  data() {
    return {
      query: {},
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 12,
      },
      data: [],
      option: {},
      loading: false,
      downloading: false,
      drawerTitle: '',
      modalShow: false,
      downloading: false,
      drawerShow: false,
      formSelectShow: false,
      processId: '',
      formId: '29',
      processKey: '',
      processInstanceId: '',
      stepMethodKey: '',
      rowData: {},
      modalTitle: '',
      modalFormLoading: false,
      auditLoading: false,
      formatData: [],
      formList: [],
      viewAll: false,
      exportObj: {},
    }
  },
  computed: {
    ...mapGetters(['permission', 'userAllInfo']),
    isWorker() {
      return this.userAllInfo.staffId === -1
    },
    permissionList() {
      return {
        addBtn: this.permission.menu_add,
        viewBtn: this.permission.menu_view,
        delBtn: this.permission.menu_del,
        editBtn: this.permission.menu_edit,
      }
    },
    statusOption() {
      const option = {
        1: {
          color: 'bg-gradient-secondary',
          send: true,
        },
        5: {
          color: 'bg-gradient-warning',
        },
        7: {
          color: 'bg-gradient-danger',
        },
        9: {
          color: 'bg-gradient-success',
        },
      }
      const defaultDictArr = this.$store.getters.dicts.dictBiz

      // 用于单独处理
      // const findDict = defaultDictArr.find(o => o.code === 'interview_ process_status')
      // if (findDict) {
      //   findDict.children.forEach(item => {
      //     if (option[item.dictKey]) {
      //       option[item.dictKey].label = item.dictValue
      //     }
      //   });
      // }
      return option
    },
  },
  watch: {
    // formId(e) {
    //   if (e) {
    //     const find = this.formList.find(o => o.id === e) || {}
    //     this.processKey = find.processKey
    //     this.processInstanceId = find.processInstanceId
    //   }
    // },
  },
  mounted() {
    const query = this.$route.query || {}
    const { title, processKey, formId, viewAll } = this.$route.query
    this.formId = formId
    this.title = title
    this.viewAll = viewAll === 'true'
    this.formList = [
      {
        formName: title,
        id: formId,
        processKey,
      },
    ]
    if (formId) {
      formAPI.detail({ id: formId }).then((res) => {
        const formDetail = res.data.data
        const configuration = formDetail.configuration || '{}'
        this.exportObj = JSON.parse(configuration).export || {}
      })
    }
    if (query.processId) {
      this.processId = query.processId
      this.stepMethodKey = 'viewPage'
      this.drawerShow = true
      // applyAPI.detail({ id: this.processId }).then(res => {
      //   const { data } = res.data
      //   this.stepMethodKey = 'viewPage'
      //   this.processKey = data.processKey
      //   this.processInstanceId = data.processInstanceId
      //   this.formId = data.formId
      //   this.rowData = data
      //   this.drawerShow = true
      // })
    }
    // templateFormAPI.getList(1, -1, { formType: 2 }).then(res => {
    //   this.formList = res.data.data.records
    // })

    const find = this.formList.find((o) => o.id === this.formId) || {}
    this.processKey = find.processKey
    this.processInstanceId = find.processInstanceId
    const filtersMap = {
      24: [
        'fileIds',
        'remark',
        'unitName',
        'resignation',
        'flightDestination',
        'lastWorkingDay',
        'arrivalDate',
        'wpExpiryDate',
      ],
      30: ['reason', 'is_commit', 'fileIds', 'remark', 'organizer'],
      29: [
        'reason',
        'is_commit',
        'fileIds',
        'remark',
        'organizer',
        'arrivalDate',
        'departureDate',
        'leaveUnit',
        'leavePeriod',
      ],
      39: ['sign', 'descriptions'],
      29: ['ticketIds'],
    }

    templateFormAPI.detail({ formId: this.formId }).then((res) => {
      let temp = res.data.data.records
      if (filtersMap[this.formId]) {
        temp = temp.filter(
          (el) =>
            filtersMap[this.formId] &&
            !filtersMap[this.formId].includes(el.fieldName)
        )
      }
      const searchList = ['29', '24']
      const newTemp = temp.filter((el) => {
        const fieldOption = JSON.parse(el.fieldOption || '{}')
        return !fieldOption.tableHide
      })

      const resArr = [
        ...templateFormat(newTemp),
        // {
        //   label: this.i18n('applicationDate'),
        //   field: 'applicationDate',
        //   search: false,
        //   searchBase: true,
        //   type: 'date',
        //   // dictBizCode: 'process_status',
        //   sort: -1,
        // },
        {
          label: this.i18n('applicationDate'),
          field: 'createTime',
          type: 'dateRange',
          search: searchList.includes(this.formId),
          searchBase: true,
          // hide: this.form
          // sort: 9999998,
        },
        {
          label: this.i18n('status'),
          field: 'status',
          dictField: 'statusName',
          type: 'select',
          search: true,
          searchBase: true,
          dictBizCode: 'process_status',
          sort: -1,
        },
      ]

      this.option = {
        header: true, // 显示顶部功能区(默认 true)

        addBtn: false, // 新增按钮(默认 true)
        viewBtn: false, // 显示按钮(默认 true)
        editBtn: false, // 修改按钮(默认 true)
        delBtn: (row) => row.status === 1, // 删除按钮(默认 true)

        search: true, // 显示搜索(默认 true)
        menu: true, // 显示菜单(默认 true)
        menuWidth: 200, // 默认200
        form: true, // 是否使用自带form (默认true)
        // drawerWidth: 500, // 默认auto
        searchVisible: false, // 搜索默认展开(默认 false)
        fixedHeader: false, // 固定表头(默认 true)
        lineNumbers: false, // 显示每行数据的下标(默认 false)
        searchSpan: 4, // 自定义搜索栅格(默认 4)

        columns: resArr,
      }

      this.onLoad(this.page)
    })
  },
  methods: {
    async onLoad(page, params = {}) {
      this.loading = true
      let res = {}
      if (this.viewAll) {
        res = await applyAPI.getWorkerList(
          page.currentPage,
          page.pageSize,
          Object.assign(params, this.query, { formId: this.formId })
        )
      } else {
        res = await applyAPI.getWorkerSelfList(
          page.currentPage,
          page.pageSize,
          Object.assign(params, this.query, { formId: this.formId })
        )
      }
      const { data } = res.data
      this.page.total = data.total
      const temp = data.records
      this.data = data.records
      const formatData = []
      temp.forEach((item) => {
        const form = item.map
        form.id = item.id
        form.processInstanceId = item.processInstanceId
        form.status = item.status
        form.statusName = item.statusName
        form.createTime = item.createTime
        formatData.push(form)
      })
      this.formatData = formatData
      this.loading = false
    },
    handleBack() {
      this.$router.go(-1) // 返回上一层
    },
    passQuery(query = {}, row) {
      let bool = true
      Object.keys(query).forEach((key) => {
        if (row[key] !== query[key]) {
          bool = false
        }
      })
      return bool
    },
    handleDownload() {
      if (this.viewAll) {
        if (this.formId === '29') {
          downLoadAllLeave(this.query).then((res) => {
            this.getBlobObj(res.data, 'Leave.xlsx')
          })
        }
        if (this.formId === '30') {
          downLoadAllWorkerForm(this.query).then((res) => {
            this.getBlobObj(res.data, 'Worker Form.xlsx')
          })
        }
        if (this.formId === '28') {
          downLoadAllProcess(this.query).then((res) => {
            this.getBlobObj(res.data, 'Passport.xlsx')
          })
        }
        if (this.formId === '24') {
          downLoadAllLeaveJob(this.query).then((res) => {
            this.getBlobObj(res.data, 'Leave Job.xlsx')
          })
        }
      } else {
        if (this.formId === '29') {
          downLoadLeave(this.query).then((res) => {
            this.getBlobObj(res.data, 'Leave.xlsx')
          })
        }
        if (this.formId === '30') {
          downLoadWorkerForm(this.query).then((res) => {
            this.getBlobObj(res.data, 'Worker Form.xlsx')
          })
        }
        if (this.formId === '28') {
          downLoadProcess(this.query).then((res) => {
            this.getBlobObj(res.data, 'Passport.xlsx')
          })
        }
        if (this.formId === '24') {
          downLoadLeaveJob(this.query).then((res) => {
            this.getBlobObj(res.data, 'Leave Job.xlsx')
          })
        }
      }
      if (this.formId == '105') {
        console.log(';ssssssssss')
        this.handleDownload()
      }
    },

    async handleDownload() {
      this.downloading = true
      const zip = new JSZip()
      const code = 'warningLetter'
      const dirName = code
      zip.folder(dirName)
      const resData = []
      const cache = {}
      const promises = []
      console.log(this.formatData)
      this.formatData.forEach((el) => {
        if (!el.files) {
          return
        }
        console.log(el.name, el.workerName, 'sss')
        el.files.forEach(async (item) => {
          const tempData = {
            url: item.link,
            originalName: `${el.name}${el.createTime}-${item.originalName}`,
          }
          console.log(tempData)
          resData.push(tempData)
        })
      })

      resData.forEach((item) => {
        const promise = this.getFile(item.url).then((data) => {
          const fileName = item.originalName
          zip.file(`${dirName}/${fileName}`, data, { binary: true })
          cache[fileName] = data
        })
        promises.push(promise)
      })
      Promise.all(promises).then(() => {
        zip.generateAsync({ type: 'blob' }).then((context) => {
          const blob = new Blob([context])
          const a = document.createElement('a')
          const resUrl = window.URL.createObjectURL(blob)
          a.href = resUrl
          a.download = `${dirName}.zip`
          a.click()
          this.downloading = false
          window.URL.revokeObjectURL(resUrl)
        })
      })
    },
    // 通过url获取具体文件并将文件转为blob对象
    getFile(url) {
      return new Promise((resolve, reject) => {
        fetch(url).then((res) => {
          resolve(res.blob())
        })
      })
    },

    downloadPDF(row) {
      const url = row?.files?.[0].link || ''
      console.log(url)
      if (url) {
        window.open(url)
      }
      // window.open(url)
    },
    handleCustomDownload(exportObj = {}, row = null) {
      const { url, params, fileType, responseType } = exportObj
      const obj = {}
      if (row) {
        Object.keys(params).forEach((key) => {
          obj[params[key]] = row[key]
        })
      } else {
        Object.keys(params).forEach((key) => {
          obj[params[key]] = this[key]
        })
      }
      const fileName = `${this.title}.${fileType}`
      customDownload(url, obj, responseType).then((res) => {
        if (responseType === 'blob') {
          this.getBlobObj(res.data, fileName)
        } else {
          const a = document.createElement('a')
          a.href = res.data.data.link
          a.download = fileName
          a.click()
        }
      })
    },
    getBlobObj(context, fileName) {
      const blob = new Blob([context])
      const a = document.createElement('a')
      const url = window.URL.createObjectURL(blob)
      a.href = url
      a.download = fileName
      a.click()
      window.URL.revokeObjectURL(url)
    },
    toHump(name) {
      // eslint-disable-next-line no-useless-escape
      return name.replace(/\_(\w)/g, (all, letter) => letter.toUpperCase())
    },
    findData(key) {
      let res = {}
      if (this.processInstanceId) {
        res =
          this.data.find(
            (o) => o.processInstanceId === this.processInstanceId
          ) || {}
      } else {
        res = this.data.find((o) => o.id === this.rowData.id) || {}
      }
      return JSON.parse(JSON.stringify(res[key]))
    },
    // i18n
    i18n(param) {
      return this.$t(`_apply.${param}`)
    },
    // 搜索按钮被点击
    async searchChange(done, e) {
      if (!this.drawerShow) {
        this.page.currentPage = 1
        const cols = this.option.columns

        const temp = deepClone(e)
        console.log(temp, 'temp=')

        Object.keys(temp).forEach((key) => {
          const item = temp[key]
          const col = cols.find((o) => o.field === key) || {}
          const colTypeIsRange = col.type === 'dateRange'
          if (colTypeIsRange) {
            const keyStart = key.replace(/createTime/, 'startTime')
            const keyEnd = key.replace(/createTime/, 'endTime')
            if (Array.isArray(item)) {
              const [start, end] = item
              temp[keyStart] = start
              temp[keyEnd] = end
              delete temp[key]
            }
          }
        })

        this.query = temp
        await this.onLoad(this.page)
      }
      done()
    },
    // 搜索重置
    searchReset() {
      this.query = {}
      this.onLoad(this.page)
    },
    refreshChange() {
      this.onLoad(this.page, this.query)
    },
    // 点击下载按钮
    rowDel(e) {
      applyAPI
        .remove(e.id)
        .then(() => {
          this.onLoad(this.page)
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('_default.toast.title'),
              icon: 'BellIcon',
              text: this.$t('_default.toast.text.success'),
              variant: 'success',
            },
          })
        })
        .catch(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('_default.toast.title'),
              icon: 'BellIcon',
              text: this.$t('_default.toast.text.danger'),
              variant: 'danger',
            },
          })
        })
    },
    // 当前页改变
    pageChange(e) {
      this.page.currentPage = e
      this.onLoad(this.page)
    },
    // 页数据数量改变
    pageSizeChange(e) {
      this.page.pageSize = e
      this.onLoad(this.page)
    },
    beforeOpen(done, type) {
      const formatDic = {
        add: 'Add',
        edit: 'Edit',
        view: 'View',
        upload: 'Upload',
      }
      this.drawerTitle = formatDic[type]
      done()
    },
    submitAdd(done, form) {
      const params = form
      applyAPI
        .add(params)
        .then(() => {
          this.onLoad(this.page)
          this.$message({
            type: 'success',
            message: this.$t('system.user.tip.success'), // "操作成功!"
          })
          done()
        })
        .catch(() => {
          done()
        })
    },
    submitEdit(done, form) {
      applyAPI
        .update(form)
        .then(() => {
          this.onLoad(this.page)
          this.$message({
            type: 'success',
            message: this.$t('system.user.tip.success'), // "操作成功!"
          })
          done()
        })
        .catch(() => {
          done()
        })
    },
    handleBeforeClose(done) {
      done()
      this.onLoad(this.page)
    },
    handleDrawerClose() {
      this.drawerShow = false
      this.onLoad(this.page)
    },
    getFormOption(key) {
      return this[`${key}Option`] || false
    },
    handleStepChange(key, row) {
      // this.formId = ''
      if (['add'].indexOf(key) !== -1) {
        this.drawerShow = true
      } else if (['edit', 'viewPage'].indexOf(key) !== -1) {
        // this.formId = row.formId
        this.processId = row.id
        this.drawerShow = true
      } else {
        this.modalShow = true
        this.modalTitle = this.$t(`_staff.prompt.base.${key}Title`)
      }
      this.stepMethodKey = key
      this.rowData = row || {}
    },
    cancelProcess(row) {
      this.$bvModal
        .msgBoxConfirm(this.i18n('cancelProcessTip'), {
          title: 'Please Confirm',
          size: 'sm',
          okVariant: 'primary',
          okTitle: 'Yes',
          cancelTitle: 'Cancel',
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.loading = true
            applyAPI
              .cancelProcess({ processInstanceId: row.processInstanceId })
              .then((res) => {
                this.onLoad(this.page)
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: this.$t('_default.toast.title'),
                    icon: 'BellIcon',
                    text: this.$t('_default.toast.text.success'),
                    variant: 'success',
                  },
                })
              })
          }
          this.loading = false
        })
    },
    // handleFormSelectConfirm() {
    //   this.drawerShow = true
    //   this.formSelectShow = false
    // },
    async handleModelConfirm() {
      this.modalFormLoading = true
      const key = this.stepMethodKey
      if (key === 'send') {
        applyAPI.start({ processId: this.rowData.id }).then((res) => {
          this.modalFormLoading = false
          this.modalShow = false
          this.onLoad(this.page)
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('_default.toast.title'),
              icon: 'BellIcon',
              text: this.$t('_default.toast.text.success'),
              variant: 'success',
            },
          })
        })
      }
    },
    getStatusOption(status) {
      return this.statusOption[status] || {}
    },
  },
}
</script>
<style lang="scss">
.apply-list {
  position: relative;
  &__title {
    position: absolute;
    left: 50%;
    top: -50px;
    transform: translateX(-50%);
  }
  &__back {
    position: absolute;
    top: -50px;
    right: 0;
  }
  .dropdown-menu {
    min-width: 13rem;
  }
}
.audit-container {
  text-align: center;
}
</style>
